<div class="logo-tile">
  <div class="logo-background" [class.logo-background__sm]="small" [style.background-image]="backgroundImg"></div>
</div>
